export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDAOdnxjb8DnQ1-2ZnHl6lpqvL3CnMovVA",
    authDomain: "quattro-b2c-qa.firebaseapp.com",
    projectId: "quattro-b2c-qa",
    storageBucket: "quattro-b2c-qa.appspot.com",
    messagingSenderId: "158340475915",
    appId: "1:158340475915:web:dde3806c79be8dd86c6b0e"
  },
  token_raspberry: "eyJhbGciOiJIUzI1NiJ9.eyJhdXRob3JpdGllcyI6IntcInR5cGVcIjpcInRva2VuXCJ9Iiwib3JpZ2luIjoiYmlpYmlpYyIsImF1ZCI6InxiaWliaWljfGF1dG9zfCIsInNxbEluc3RhbmNlSWQiOiJkYjgiLCJzcWxJbnN0YW5jZU5hbWUiOiJxdWF0dHJvY3JtLWRiOCIsImRibiI6InF1YXR0cm8wMDQ2MiIsInNvY2lvRW5jIjoiTkhaYWNNYm9NbXYzN2E4d3FEdFFEQT09IiwicGVyc29uYUVuYyI6Ijk0YzNxYUJUbE9CYmRVV1BCa3hFbWc9PSIsInN1YiI6InE0NjJAcXVhdHRyb2NybS5teCIsImlhdCI6MTcxNjIzNTUzNCwiZXhwIjoxNzQ3MzM5NTM0fQ.OEEKBbace27GWENZUpDhFMJKmVrCPCTptS2P33GRobM",
  pasarelaMedipet : "https://ewsdesa.gmx.com.mx/MPEnero/SSV/SSVRequest.aspx",
  appProduct : "1N7R5P8"
};
